module.exports = __webpack_public_path__ + "images/logout-icon-ded02a60e6029374e42e916f1faf94c8.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/logout-icon.png
// module id = ./client/assets/images/logout-icon.png
// module chunks = 5 7 8